module.exports = __webpack_public_path__ + "static/media/iprotech_sc.217451c7.png";